module.exports = __webpack_public_path__ + "media/components/src/assets/images/upload-img/upload-img-4cd00d3972c210b2f9e6bf4c4d4cfde0.png";